// extracted by mini-css-extract-plugin
module.exports = {"title":"title__2v2J_","errorLink":"errorLink__3JwY0"};